module.exports = __webpack_public_path__ + "static/img/img_bmfx.98c6c741.png";